import { render, staticRenderFns } from "./SyllabusEdit.vue?vue&type=template&id=13b76c0b&"
import script from "./SyllabusEdit.vue?vue&type=script&lang=js&"
export * from "./SyllabusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports